<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Платежи</h2>
          <div class="px-3"></div>
          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-3"
                label="дата"
                v-model="day"
                v-on="on"
                style="max-width: 200px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              locale="ru" first-day-of-week="1"
              v-model="day" :landscape="true" :reactive="true"
              @change="fetch"
            ></v-date-picker>
          </v-menu>

          <v-select
          :items="agents"
          v-model="agent"
          label="Агент"
          class="mx-3"
          hide-details
          clearable
          style="max-width: 200px"
          ></v-select>

          <div class="px-3">Платежей: <b>{{ count }}</b></div>
          <div class="px-3">Сумма: <b>{{ rubles(sum) }}</b></div>

          <v-menu offset-y bottom :close-on-content-click="false">
            <template v-slot:activator="{ on }">
              <v-btn
                fab small
                class="mx-3 elevation-0"
                v-on="on"
                hide-details
              ><v-icon color="secondary">view_list</v-icon></v-btn>
            </template>
            <v-card>
              <v-card-text>
                <v-data-table
                :headers="[{text: 'агент', value: 'name'},{text: 'сумма', value: 'sum'},{text: 'зачислено', value: 'count'},{text: 'провалено', value: 'failed'}]"
                :items="Object.values(byAgent)"
                class="elevation-0"
                :items-per-page="-1"
                hide-default-footer
                >
                  <template v-slot:item.sum="{ item }">
                    {{ rubles(item.sum) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-menu>

          <v-spacer></v-spacer>

          <v-text-field
          label="поиск по фильтру"
          v-model="search"
          append-icon="search"
          style="max-width: 400px"
          outlined clearable hide-details flat
          ></v-text-field>
        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          :footer-props="footerProps" no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page.sync="itemsPerPage"
          :headers="headers"
          :items="filtered"
          :items-per-page="itemsPerPage"
          :search="search"
          item-key="name" :sort-by="null"
          dense text
          class="pt-2"
        >
          <template v-slot:item.orgid="{ item }">
            <v-btn
              text small color="primary" class="no-text-transform"
              @click="agent=item.orgid"
            >{{ item.orgid }}</v-btn>
          </template>
          <template v-slot:item.cts="{ item }">
            {{ dateFormat(item.cts) }}
          </template>
          <template v-slot:item.amount="{ item }">
            {{ rubles(item.amount) }}
          </template>
          <template v-slot:item.personid="{ item }">
            <router-link
              :to="{ name: 'person', params: { personid: item.personid } }"
              style="color: inherit; text-decoration: none"
              >
              {{ item.personid }}
              <v-icon small>call_made</v-icon>
            </router-link>
          </template>
          <template v-slot:item.cardid="{ item }">
            <router-link
              :to="{ name: 'person', params: { personid: item.personid } }"
              style="color: inherit; text-decoration: none"
              >
              {{ item.cardid }}
              <v-icon small>call_made</v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
export default {
  name: 'Payments',
  data: () => ({
    day:  moment().format('YYYY-MM-DD'),
    search: '',
    payments: [],
    agent: null,
    headers: [
      { text: 'status', value: 'status' },
      { text: 'orgid', value: 'orgid' },
      { text: 'amount', value: 'amount' },
      { text: 'cardid', value: 'cardid' },
      { text: 'ticket', value: 'ticket' },
      { text: 'originaldate', value: 'originaldate' },
      { text: 'cts', value: 'cts' },
      { text: 'personid', value: 'personid' },
      { text: 'transferid', value: 'transferid' },
      { text: 'operator', value: 'operator' },
    ],
    footerProps: {
      itemsPerPageText: 'показывать записей',
      itemsPerPageOptions: [ 20, 100, { text:'Все', value:-1 } ]
    },
    itemsPerPage: 20
  }),
  methods: {
    async fetch () {
      try {
        const { payments, meta } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-payments', pl: { day: this.day }
        })
        this.payments = payments
      } catch (e) {
        this.$store.dispatch('snack', e)
      }
    },
    dateFormat (date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    byAgent () {
      return this.payments.reduce((r, x) => {
        if (!r[x.orgid]) r[x.orgid] = { name: x.orgid, count: 0, sum: 0, failed: 0 }
        if (x.transferid) {
          r[x.orgid].sum += x.amount
          r[x.orgid].count += 1
        } else {
          r[x.orgid.failed] += 1
        }
        return r
      }, {})
    },
    sum () {
      return this.filtered.reduce((r, x) => {
        if (x.transferid) r += x.amount
        return r
      }, 0)
    },
    count () {
      return this.filtered.reduce((r, x) => {
        if (x.transferid) r++
        return r
      }, 0)
    },
    agents () {
      return this.payments.reduce((r, x) => {
        if (!r.includes(x.orgid)) r.push(x.orgid)
        return r
      }, [])
    },
    filtered () {
      if (this.agent) {
        return this.payments.filter(x => x.orgid === this.agent)
      } else {
        return this.payments
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    }
  },
  mounted () {
    if (this.profile) this.fetch()
  }
}
</script>

<style lang="css">
</style>
